export const Types = {
    TASK_LIST: "TASK_LIST",
  };